// extracted by mini-css-extract-plugin
export default {"advertDetailContactItem":"c-n_fL","advertDetailContactItem__link":"c-n_fM"};